import React, { useEffect } from "react";

import { OrganizationFeatures } from "components/OrganizationFeatures";
import {
  useCurrentOrganization,
  useCurrentServer,
} from "components/WithCurrentOrganization";
import Help from "components/Help";
import LoadingErrorBoundary from "components/LoadingErrorBoundary";
import OutdatedCollectorNotice from "components/OutdatedCollectorNotice";
import WebsocketUnhealthy from "components/WebsocketUnhealthy";
import PageSideNav from "components/PageSideNav";
import StatusNotice from "components/StatusNotice";
import WarnIfPastDue from "components/WarnIfPastDue";
import WarnIfSamlCertExpiring from "components/WarnIfSamlCertExpiring";
import WarnIfServerOverage from "components/WarnIfServerOverage";

import styles from "./style.module.scss";
import { useUserPreferences } from "utils/hooks";

type Props = {
  content: React.ReactNode;
};

const PageLayout: React.FunctionComponent<Props> = ({ content }) => {
  const {
    humanId: serverId,
    lastSnapshot,
    hasRecentSnapshot,
    createdAt,
    connectionAge,
    usesLegacyHttpApi,
  } = useCurrentServer(true) ?? {};
  const { id, slug } = useCurrentOrganization(true) ?? {};
  const [lastVisited, setLastVisited] = useUserPreferences("lastVisitedOrg");
  useEffect(() => {
    if (id && slug && (slug !== lastVisited.slug || !lastVisited.id)) {
      setLastVisited({ id, slug });
    }
  }, [id, slug, lastVisited, setLastVisited]);

  return (
    <OrganizationFeatures>
      <div className={styles.page}>
        <Help />
        <WarnIfPastDue />
        <WarnIfServerOverage />
        <WarnIfSamlCertExpiring />
        <StatusNotice />
        <OutdatedCollectorNotice
          serverId={serverId}
          hasRecentSnapshot={hasRecentSnapshot}
          collectorVersion={lastSnapshot?.collectorVersionStr}
        />
        <WebsocketUnhealthy
          serverId={serverId}
          hasRecentSnapshot={hasRecentSnapshot}
          createdAt={createdAt}
          connectionAge={connectionAge}
          usesLegacyHttpApi={usesLegacyHttpApi}
        />
        <PageSideNav />
        <div className={styles.content}>
          <LoadingErrorBoundary>{content}</LoadingErrorBoundary>
        </div>
      </div>
    </OrganizationFeatures>
  );
};

export default PageLayout;
